<div class="flex items-center justify-center dialog-header">
  {{type}} Department

  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>

<div class="dialog-content">
  <form [formGroup]="departmentForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">
    <!-- Campus -->
    <div class="flex flex-col">
      <label for="campus_id" class="mb-2 font-semibold">Campus *</label>
      <p-select id="campus_id" formControlName="campus_id" [options]="campuses" optionLabel="name" optionValue="campus_id"
        placeholder="Select a campus" class="w-full"></p-select>
      <div *ngIf="departmentForm.get('campus_id')?.invalid && (departmentForm.get('campus_id')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Campus is required.
      </div>
    </div>

    <!-- Name -->
    <div class="flex flex-col">
      <label for="name" class="mb-2 font-semibold">Name *</label>
      <input pInputText id="name" formControlName="name"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="departmentForm.get('name')?.invalid && (departmentForm.get('name')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Name is required.
      </div>
    </div>

    <!-- Code -->
    <div class="flex flex-col">
      <label for="code" class="mb-2 font-semibold">Code *</label>
      <input pInputText id="code" formControlName="code"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="departmentForm.get('code')?.invalid && (departmentForm.get('code')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Code is required.
      </div>
    </div>

    <!-- Head of Department -->
    <div class="flex flex-col">
      <label for="head_of_department" class="mb-2 font-semibold">Head of Department</label>
      <p-select id="head_of_department" formControlName="head_of_department"
        [options]="users"
        placeholder="Select a Department" class="w-full">
      </p-select>
      <div
        *ngIf="departmentForm.get('head_of_department')?.invalid && (departmentForm.get('head_of_department')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Head of Department is required.
      </div>
    </div>
    

    <!-- Description -->
    <div class="flex flex-col">
      <label for="description" class="mb-2 font-semibold">Description</label>
      <textarea pInputText id="description" formControlName="description"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" rows="3"></textarea>
    </div>

    <!-- Contact Number -->
    <div class="flex flex-col">
      <label for="contact_number" class="mb-2 font-semibold">Contact Number</label>
      <input pInputText id="contact_number" formControlName="contact_number"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <!-- Email -->
    <div class="flex flex-col">
      <label for="email" class="mb-2 font-semibold">Email *</label>
      <input pInputText id="email" formControlName="email"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="departmentForm.get('email')?.errors?.['email'] && (departmentForm.get('email')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Invalid email format.
      </div>
    </div>

    <!-- Status -->
    <div class="flex flex-col">
      <label for="status" class="mb-2 font-semibold">Status *</label>
      <p-select id="status" [options]="statusOptions" formControlName="status" placeholder="Select a status"
        class="w-full" />
      <div *ngIf="departmentForm.get('status')?.invalid && (departmentForm.get('status')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Status is required.
      </div>
    </div>

    <!-- Is Public -->
    <!--  <div class="flex flex-col">
      <label for="is_public" class="mb-2 font-semibold">Public *</label>
      <p-checkbox id="is_public" formControlName="is_public"></p-checkbox>
    </div>
 -->
    <!-- Submit Button -->
    <div class="col-span-2 flex justify-end mt-6">
      <p-button label="Submit" type="submit" [loading]="isLoading" icon="pi pi-check" class="w-full"
        [disabled]="departmentForm.invalid || isLoading"></p-button>
    </div>
  </form>
</div>